import { postFinderList, getAmexPlatinumVenues } from '../../../../../ui-kitchen/src/api/api';
import { finder4Transform } from '../../../../../ui-kitchen/src/api/resyApiTransformer';
import Logger from '../../../../../ui-kitchen/src/utils/logger';
import getImage from '../AmexMarketingUtils/getAmexImage';
import {
  fetchS3JsonFile,
} from '../AmexMarketingUtils/AmexUtils';
import {
  FOLDER_NAME, ALL_CITIES_DATA, IMAGE_PATH, NAA_SECTION, MGM_SECTION,
  DESKTOP_IMAGE_SIZE, MOBILE_IMAGE_SIZE, DATE_FORMAT, COMING_SOON_STATUS, DINNER_SERVICE_TYPE_ID,
  NOTIFY_STATUS, BOOK_NOW_STATUS, ALL_CITIES_WITH_DATA_REFRESH, ALL_CITIES_DATA_REFRESH,
} from './constants';

const getVenuesArray = (results) => results
  .filter((result) => result.status === 'fulfilled' && result.value)
  .map((fulfilledResult) => fulfilledResult.value);

export const getPlatinumDetails = async (testingValue, baseRequestUrl, mockApiDataFile, venueDataValue) => {
  let platNightsResponse = {};
  let updatedPlatNightsResponse = null;
  if (testingValue === 'true' && ENV !== 'prod') platNightsResponse = await fetchS3JsonFile(baseRequestUrl, FOLDER_NAME, mockApiDataFile);
  else {
    try {
      platNightsResponse = await getAmexPlatinumVenues();
    } catch (error) {
      Logger.error('ERROR [Platinum Nights] - Error Platinum Nights API Response -- ', error);
      return null;
    }
  }

  if (venueDataValue) {
    updatedPlatNightsResponse = platNightsResponse?.platinum_nights?.map((platItem) => {
      const venueItemMatch = venueDataValue.find((venueItem) => ((venueItem.venue_id === platItem.venue_id)
    && moment(venueItem.platinum_night_date, DATE_FORMAT).isSame(moment(platItem.platinum_night_date, DATE_FORMAT))));
      platItem.image = venueItemMatch?.image;
      platItem.reservation_info = venueItemMatch?.reservation_info;
      platItem.notifyButton = venueItemMatch?.notifyButton;
      return platItem;
    });
  } else updatedPlatNightsResponse = platNightsResponse?.platinum_nights;

  return updatedPlatNightsResponse?.length !== 0 ? updatedPlatNightsResponse : null;
};

export const getLocationArray = (platinumResponse) => {
  const locationArr = [ALL_CITIES_DATA];
  platinumResponse?.forEach((item) => {
    locationArr.push({ name: item.city, url_slug: item.city, code: item.city });
  });

  const filteredLocArr = locationArr.reduce((addedLocs, current) => {
    const isPresent = addedLocs.find((itemValue) => itemValue.name === current.name);
    if (!isPresent) {
      return addedLocs.concat([current]);
    }
    return addedLocs;
  }, []);

  return filteredLocArr;
};

// convert this array platinumCities to a format similar to locationArr with name, url_slug, code and data as false by using the resyLocations data
const convertPlatinumCityCodesToLocationArr = (resyLocations, platinumCities) => {
  const allPlatinumCitiesArray = platinumCities?.map((code) => ({
    name: resyLocations.find((location) => location.code === code)?.name,
    url_slug: resyLocations.find((location) => location.code === code)?.url_slug,
    code,
    data: false,
  }));
  return allPlatinumCitiesArray || [];
};

export const getLocationArrayWithConfigData = (platinumResponse, allResyLocations, platinumCities) => {
  const allPlatinumCitiesArray = convertPlatinumCityCodesToLocationArr(allResyLocations, platinumCities);
  const locationArr = [...allPlatinumCitiesArray, (platinumResponse && platinumResponse?.length > 0) ? ALL_CITIES_WITH_DATA_REFRESH : ALL_CITIES_DATA_REFRESH];
  if (platinumResponse?.length === 0) {
    return locationArr;
  }
  platinumResponse?.forEach((item) => {
    locationArr.push({
      name: item.city,
      url_slug: allResyLocations?.find((location) => location.name === item.city)?.url_slug,
      code: allResyLocations?.find((location) => location.name === item.city)?.code,
      data: true,
    });
  });

  const filteredLocArr = locationArr.reduce((addedLocs, current) => {
    const existingIndex = addedLocs.findIndex((itemValue) => itemValue.name === current.name);
    if (existingIndex === -1) {
      return addedLocs.concat([current]);
    }

    if (current.data === true && addedLocs[existingIndex]?.data === false) {
      return [
        ...addedLocs.slice(0, existingIndex),
        current,
        ...addedLocs.slice(existingIndex + 1),
      ];
    }

    return addedLocs;
  }, []);

  return filteredLocArr;
};

export const getMonthArray = (platinumResponse) => {
  const updatedVenues = [];
  const MONTH_LABELS = moment().localeData().months();
  let monthObj = null;
  platinumResponse?.forEach((venueItem) => {
    const venueDate = moment(venueItem.platinum_night_date, 'YYYY-MM-DD');
    const venueMonth = venueDate.month();
    const monthName = MONTH_LABELS[venueMonth];
    const padZero = (num) => (num < 10 ? '0' : '') + num;
    const str = padZero(venueMonth + 1);
    monthObj = { key: str, value: str, label: monthName };

    if (updatedVenues.filter((venueMont) => (venueMont.label === monthObj.label))?.length === 0) {
      updatedVenues.push(monthObj);
    }
  });
  return updatedVenues;
};

const getVenueImagePathWithSize = (venueImagePath, isDesktop) => {
  if (!venueImagePath) return null;
  const pathSegments = venueImagePath?.split('/').filter((segment) => segment !== '');
  const imageSizeSlug = isDesktop ? DESKTOP_IMAGE_SIZE : MOBILE_IMAGE_SIZE;
  pathSegments[pathSegments.length - 1] = imageSizeSlug;
  const newVenueImagePath = `https://${pathSegments.slice(1, pathSegments.length).join('/')}`;
  return newVenueImagePath;
};
export const getDeviceSpecificImages = (responsiveImages, isDesktop, item, baseRequestUrl) => {
  let newVenueImagePath = '';
  if (item.image) {
    const deviceType = isDesktop ? 'desktop' : 'mobile';
    newVenueImagePath = (item.image?.api_index >= 0) ? getVenueImagePathWithSize(getImage(responsiveImages, null, false, item.image?.api_index), isDesktop)
      : `${baseRequestUrl}${FOLDER_NAME}/${IMAGE_PATH}/${item.image?.responsive_images[deviceType]}`;
  } else {
    newVenueImagePath = getVenueImagePathWithSize(getImage(responsiveImages, null, false), isDesktop);
  }
  return newVenueImagePath;
};

const getVenueStatus = (venue, slots) => {
  const dinnerSlots = slots?.filter((slot) => slot.serviceTypeId === DINNER_SERVICE_TYPE_ID);
  const hasNotifications = dinnerSlots?.length === 0;

  if (venue?.platinum_night_status === COMING_SOON_STATUS) return venue?.platinum_night_status;
  if (hasNotifications) return NOTIFY_STATUS;
  return BOOK_NOW_STATUS;
};

export const getUniqueVenueLocationsWithBookableStatus = (venuesArray = []) => {
  const locationsMap = venuesArray.reduce((acc, venue) => {
    const locationName = venue?.locationName;
    const locationSlug = venue?.locationSlug;

    if (!locationName || !locationSlug) return acc;

    const locationKey = `${locationName}::${locationSlug}`;
    const isBookNowStatus = venue?.status === BOOK_NOW_STATUS || venue?.status === 'Book Now';
    const existingLocation = acc[locationKey];

    acc[locationKey] = {
      locationName,
      locationSlug,
      isBookable: existingLocation ? existingLocation.isBookable || isBookNowStatus : isBookNowStatus,
    };

    return acc;
  }, {});

  return Object.values(locationsMap);
};

export const getVenueDetails = async (baseRequestUrl, platinumResponse, guests = 2, isDesktop = true) => {
  if (!platinumResponse || platinumResponse?.length === 0) return { venues: [], uniqueVenueLocationsWithBookableStatus: [] };
  const venuesArray = await Promise.allSettled(platinumResponse?.map(async (item) => {
    if (!item) return null;

    const params = {
      lat: 0,
      long: 0,
      day: item.platinum_night_date,
      party_size: guests,
      venue_id: item.venue_id,
      resy_token: undefined,
      time_filter: undefined,
    };
    let responseVenue = {};
    try {
      responseVenue = await postFinderList(params);
    } catch (error) {
      Logger.error('ERROR [Platinum Nights] - Error Venue API Response -- ', error);
      return null;
    }

    const apiResponse = finder4Transform(responseVenue);
    const venueResponse = apiResponse?.results?.venues[0];

    if (venueResponse === null) return null;

    const {
      venue: {
        isGda,
        cuisine,
        responsiveImages,
        urlSlug: venueSlug,
        location,
        name: venueName,
        activeNotifications,
        availableServiceTypes,
        id,
        featureRecaptcha,
      },
      slots,
    } = venueResponse;

    const venueImage = getDeviceSpecificImages(responsiveImages, isDesktop, item, baseRequestUrl);
    const status = getVenueStatus(item, slots);

    const updatedVenueResponse = {
      isGda,
      cuisine,
      locationName: location?.name,
      locationSlug: location?.urlSlug,
      venueSlug,
      venueName,
      image: venueImage,
      date: item?.platinum_night_date,
      status,
      activeNotifications,
      availableServiceTypes,
      venueId: id,
      featureRecaptcha,
      slots,
      partySize: guests,
      venueInfo: item.landing_page_copy,
      revervationInfo: item.reservation_info,
      isNotifyHidden: item.notifyButton?.hidden || false,
      hideNotifyMessage: item.notifyButton?.hideMessage,
    };

    return updatedVenueResponse;
  }))
    .then((results) => getVenuesArray(results));

  return {
    venues: venuesArray,
    uniqueVenueLocationsWithBookableStatus: getUniqueVenueLocationsWithBookableStatus(venuesArray),
  };
};

export const findClosestCityCode = (resyLocations, displayedLocations) => resyLocations.find((location) => !!(location.country_code === 'US'
  && displayedLocations.some((displayedLocation) => displayedLocation.code === location.code)));

export const findAllDisplayedCityNames = (resyLocations, displayedLocations) => {
  const locationArr = [ALL_CITIES_DATA];

  resyLocations.forEach((resyLoc) => {
    if (displayedLocations.some((displayLoc) => resyLoc.name === displayLoc.name)) {
      locationArr.push(resyLoc);
    }
  });
  return locationArr;
};

export const findAllDisplayedCityNamesRefresh = (allResyLocations, displayedLocations) => {
  const locationArr = displayedLocations.filter((displayedLocation) => displayedLocation.code === 'all_cities');

  allResyLocations.forEach((resyLoc) => {
    if (displayedLocations.some((displayLoc) => resyLoc.name === displayLoc.name)) {
      resyLoc = {
        ...resyLoc,
        data: displayedLocations.find((displayLoc) => displayLoc.name === resyLoc.name)?.data,
      };
      locationArr.push(resyLoc);
    }
  });
  return locationArr;
};

export const isUserInPlatinumCity = (resyLocation, displayedLocations) => {
  if (!resyLocation || !resyLocation.code || !Array.isArray(displayedLocations)) return false;
  return displayedLocations.some((displayedLocation) => displayedLocation.code === resyLocation.code);
};

export const getUserPlatinumCity = (nearestResyLocation, displayedLocations) => {
  if (!nearestResyLocation || !nearestResyLocation.code || !Array.isArray(displayedLocations)) return null;
  return displayedLocations.find((displayedLocation) => displayedLocation.code === nearestResyLocation.code) || null;
};

export const getAllCitiesLocation = (allDisplayedLocations) => {
  if (!Array.isArray(allDisplayedLocations)) return null;
  return allDisplayedLocations.find((displayedLocation) => displayedLocation.code === 'all_cities') || null;
};

export const findNaaOrMgmUrl = (location) => {
  let sectionName = '';
  const pathArr = location.split('/');
  let urlPathValue = '';
  if (pathArr.length === 2) {
    [, urlPathValue] = pathArr;
    if (urlPathValue === 'platinum-member') {
      sectionName = MGM_SECTION;
    } else if (urlPathValue === 'amex-platinum') {
      sectionName = NAA_SECTION;
    }
  }
  return sectionName;
};

export const getNoVenuesMessageData = (citySlug, displayedLocations = [], messageConfig = {}) => {
  const locationItem = displayedLocations.find((location) => location?.url_slug === citySlug);
  const cityName = locationItem?.name || '';
  const templateText = messageConfig?.text || '';
  const updatedText = templateText.replace('{city_name}', cityName);
  const [textBeforeLink = '', textAfterLink = ''] = updatedText.split('{link}');
  let hrefUpdated = '';
  if (messageConfig?.link?.href) {
    hrefUpdated = citySlug !== '' ? `${messageConfig?.link?.href}cities/${citySlug}` : messageConfig?.link?.href;
  }
  return {
    textBeforeLink,
    linkText: messageConfig?.link?.text || '',
    href: hrefUpdated,
    textAfterLink: textAfterLink || '',
  };
};

export const combineUniqueVenueLocationsWithBookableStatusAndLocations = (
  uniqueVenueLocations = [],
  allLocations = []
) => {
  const combinedMap = uniqueVenueLocations.reduce((acc, location) => {
    const locationName = location?.locationName;
    const locationSlug = location?.locationSlug;
    if (!locationName || !locationSlug) return acc;

    const key = `${locationName}::${locationSlug}`;
    acc[key] = {
      locationName,
      locationSlug,
      isBookable: !!location?.isBookable,
    };
    return acc;
  }, {});

  allLocations.forEach((location) => {
    const locationName = location?.name;
    const locationSlug = location?.url_slug;
    if (!locationName || locationSlug === undefined || locationSlug === null) return;

    const key = `${locationName}::${locationSlug}`;
    if (!combinedMap[key]) {
      combinedMap[key] = {
        locationName,
        locationSlug,
        isBookable: false,
      };
    }
  });

  const combinedLocations = Object.values(combinedMap);
  const hasBookableLocation = combinedLocations.some((location) => location.locationSlug !== '' && location.isBookable);

  return combinedLocations.map((location) => (
    location.locationSlug === ''
      ? { ...location, isBookable: hasBookableLocation }
      : location
  ));
};

export const shouldShowResyCreditSection = ({
  selectedSlug = '',
  isCardMember = false,
  combinedBookableLocations = [],
  isFilterNoData = false,
}) => {
  if (selectedSlug === '') return false;
  if (!isCardMember) return true;

  if (combinedBookableLocations?.length > 0) {
    const isBookable = combinedBookableLocations
      ?.find((location) => location?.locationSlug === selectedSlug)?.isBookable;
    if (!isBookable) return true;
    if (isBookable && isFilterNoData) return true;
  }

  return false;
};

export const isAllVenuesNotifyOrComingSoon = (venues = []) => {
  if (!Array.isArray(venues) || venues.length === 0) return false;

  return venues.every((venue) => (
    venue?.status === NOTIFY_STATUS || venue?.status === COMING_SOON_STATUS
  ));
};

const parseMonthIndex = (monthIndexInput) => {
  if (monthIndexInput === null || monthIndexInput === undefined) return null;

  const normalizedIndex = Number.parseInt(`${monthIndexInput}`.trim(), 10);
  if (Number.isNaN(normalizedIndex) || normalizedIndex < 0 || normalizedIndex > 11) return null;

  return normalizedIndex;
};

export const getFirstDayOfMonthFromName = (monthIndexInput, year = moment().year()) => {
  const monthIndex = parseMonthIndex(monthIndexInput);
  if (monthIndex === null) return null;

  return moment({ year, month: monthIndex, day: 1 }).format('YYYY-MM-DD');
};

export const getCurrentDateIfMonthIsCurrent = (monthIndexInput) => {
  const monthIndex = parseMonthIndex(monthIndexInput);
  if (monthIndex === null) return null;

  const currentMonthIndex = moment().month();
  if (monthIndex !== currentMonthIndex) return null;

  return moment().format('YYYY-MM-DD');
};

export default getVenueDetails;
